import React from 'react';
import { Menu } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import { Link } from 'wouter';

<Link to='/manuale_utente'></Link>

export default function DropdownButton() {
  return (
    <Menu as="div" className="relative inline-block text-left">
        <div className='shadow-md '>
            <Menu.Button className="inline-flex items-center gap-x-2 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-indigo-500">
                <QuestionMarkIcon className="text-gray-800" style={{ height: '18px', width: '20px' }} />
                <span>Aiuto</span>
                <ChevronDownIcon className="w-6 h-6 text-gray-800" aria-hidden="true" />
            </Menu.Button>
        </div>

      <Menu.Items className="absolute right-0 z-10 mt-2 border border-gray-200 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
        <div className="py-1">
            <Menu.Item>
            {({ active }) => (
                <Link
                    to="/manuale_utente"
                    className={`flex items-center gap-1 px-4 py-2 text-sm ${
                        active ? 'bg-indigo-50 text-gray-900' : 'text-gray-700'
                    }`}
                >
                    <MenuBookIcon className="text-gray-600" style={{ height: '20px', width: '30px' }} />
                    Documentazione
                </Link>
            )}
            </Menu.Item>

            <Menu.Item>
                {({ active }) => (
                    <a
                    href="https://consultalahr.com/videoguida/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`flex items-center gap-1 px-4 py-2 text-sm ${
                        active ? 'bg-indigo-50 text-gray-900' : 'text-gray-700'
                    }`}
                    >
                    <OndemandVideoIcon
                        className="text-gray-600"
                        style={{ height: '20px', width: '30px' }}
                    />
                    Videoguida
                    </a>
                )}
            </Menu.Item>
        </div>
      </Menu.Items>
    </Menu>
  )
}
